import React from 'react';

export default function ProductQuantity({ product, className = '', showUnits = false }) {
  return <span className={className}>
    <span className='admin-product-stock-quantity'>
      {product.quantity ?? 0}{showUnits ? ' шт.' : ''}
    </span>
  </span>;
}
